import * as Yup from "yup";

export const learnValidation = Yup.object().shape({
  link: Yup.string()
  .required("وارد کردن لینک ویدئو الزامی است"),
  name: Yup.string()
    .required("وارد کردن نام الزامی است")
    .min(3, "نام باید حد اقل 3 حرفی باشد.!"),
});
